/* eslint-disable no-unused-vars */
import { Typography } from "@mui/material";
import PCheck from "../../components/pos/PCheck";
import PSettingsCard from "../../components/pos/PSettingsCard.jsx";
import PText from "../../components/pos/PText";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export default function SaleSettings(props) {
  const { t } = useTranslation();
  const translate = t;
  const [liveValidation, setLiveValidation] = useState(false);

  const [dayOpenClose, setDayOpenClose] = useState(false);
  const [receiptPrinting, setReceiptPrinting] = useState(false);
  const [includeTaxInAdjustedPrice, setIncludeTaxInAdjustedPrice] =
    useState(false);
  const [discountOnFinalPrice, setDiscountOnFinalPrice] = useState(false);
  const [directSettlement, setDirectSettlement] = useState(false);

  const [poleDisplayDefaultMessage1, setPoleDisplayDefaultMessage1] =
    useState("");
  const [poleDisplayDefaultMessage2, setPoleDisplayDefaultMessage2] =
    useState("");
  const [duplicateInvoice, setDuplicateInvoice] = useState(false);
  const [creditLimitOverride, setCreditLimitOverride] = useState(false);
  const [limitDaysOverride, setLimitDaysOverride] = useState(false);
  const [allowHoldInvoice, setAllowHoldInvoice] = useState(false);
  const [preventZeroStockSale, setPreventZeroStockSale] = useState(false);
  const [preventBelowCostSale, setPreventBelowCostSale] = useState(false);

  const [poleDisplayDefaultMessage1Error, setSoleDisplayDefaultMessage1Error] =
    useState("");
  const [poleDisplayDefaultMessage2Error, setSoleDisplayDefaultMessage2Error] =
    useState("");
  const [saveOptionInSales, setSaveOptionInsales] = useState(false);
  const [allowSalePaymentWithoutCustomer, setAllowSalePaymentWithoutCustomer] =
    useState(true);
  const [enableRoundoffSaleAmount, setEnableRoundoffSaleAmount] =
    useState(false);
  const [roundOffFactor, setRoundOffFactor] = useState(1);
  const [showPrintConfirmation, setShowPrintConfirmation] = useState(false);
  const [autoClosePayment, setAutoClosePayment] = useState(true);
  const [itemNotFoundAlert, setItemNotFoundAlert] = useState(true);
  const [showLastBillSummary, setShowLastBillSummary] = useState(false);
  const [emailWithInvoiceAttachment, setEmailWithInvoiceAttachment] =
    useState(false);
  const [denominationInDayClose, setDenominationInDayClose] = useState(false);
  const [voidReceipt, setVoidReceipt] = useState(false);
  const [enableTakeAwayToken, setEnableTakeAwayToken] = useState(true);
  const [showTerminalInfoOnSaleScreen, setShowTerminalInfoOnSaleScreen] =
    useState(false);
  const [showKeyboardShortcuts, setShowKeyboardShortcuts] = useState(false);
  const content = (
    <table width="100%">
      <tbody>
        <tr>
          <td width={200}>
            <PCheck
              onChange={(value) => setDayOpenClose(value)}
              checked={dayOpenClose}
              label={translate("Day Open/Close flow")}
            ></PCheck>
          </td>
        </tr>
        <tr>
          <td width={200}>
            <PCheck
              onChange={(value) => setReceiptPrinting(value)}
              checked={receiptPrinting}
              label={translate("Receipt Print")}
            ></PCheck>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <PCheck
              onChange={(value) => setIncludeTaxInAdjustedPrice(value)}
              checked={includeTaxInAdjustedPrice}
              label={translate("Include Tax in adjusted Price")}
            ></PCheck>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <PCheck
              onChange={(value) => setDiscountOnFinalPrice(value)}
              checked={discountOnFinalPrice}
              label={translate("Apply discount on Final Price")}
            ></PCheck>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <PCheck
              onChange={(value) => setDirectSettlement(value)}
              checked={directSettlement}
              label={translate("Direct Settlement without Payment popup")}
            ></PCheck>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <PCheck
              onChange={(value) => setDuplicateInvoice(value)}
              checked={duplicateInvoice}
              label={translate("Duplicate Invoice Prompt")}
            ></PCheck>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <PCheck
              onChange={(value) => setAllowHoldInvoice(value)}
              checked={allowHoldInvoice}
              label={translate("Allow Day close with Hold Invoice")}
            ></PCheck>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <PCheck
              onChange={(value) => setCreditLimitOverride(value)}
              checked={creditLimitOverride}
              label={translate("Block purchases exeeding credit Amount limit ")}
            ></PCheck>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <PCheck
              onChange={(value) => setPreventZeroStockSale(value)}
              checked={preventZeroStockSale}
              label={translate("Prevent Zero Stock Sale")}
            ></PCheck>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <PCheck
              onChange={(value) => setPreventBelowCostSale(value)}
              checked={preventBelowCostSale}
              label={translate("Prevent below Cost Sale")}
            ></PCheck>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <PCheck
              onChange={(value) => setLimitDaysOverride(value)}
              checked={limitDaysOverride}
              label={translate("Block purchases exeeding Due date")}
            ></PCheck>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <PCheck
              onChange={(value) => setSaveOptionInsales(value)}
              checked={saveOptionInSales}
              label={translate("Enable Save Option in Sales")}
            ></PCheck>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <PCheck
              onChange={(value) => setAllowSalePaymentWithoutCustomer(value)}
              checked={allowSalePaymentWithoutCustomer}
              label={translate("Allow sale without customer")}
            ></PCheck>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <PCheck
              onChange={(value) => setEnableRoundoffSaleAmount(value)}
              checked={enableRoundoffSaleAmount}
              label={translate("Round off sale amount")}
            ></PCheck>
          </td>
        </tr>
        <tr>
          <td>
            <Typography variant="body1">
              {translate("Round off Factor")}
            </Typography>
          </td>
          <td width={200}>
            <PText
              type={"number"}
              value={roundOffFactor}
              onChange={(e) => setRoundOffFactor(e.target.value)}
            ></PText>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <PCheck
              onChange={(value) => setShowPrintConfirmation(value)}
              checked={showPrintConfirmation}
              label={translate("Show Print Confirmation")}
            ></PCheck>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <PCheck
              onChange={(value) => setAutoClosePayment(value)}
              checked={autoClosePayment}
              label={translate("Automatically Close Payment on Settle")}
            ></PCheck>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <PCheck
              onChange={(value) => setItemNotFoundAlert(value)}
              checked={itemNotFoundAlert}
              label={translate("Item Not Found Alert")}
            ></PCheck>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <PCheck
              onChange={(value) => setShowLastBillSummary(value)}
              checked={showLastBillSummary}
              label={translate("Show Last Bill Summary popup")}
            ></PCheck>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <PCheck
              onChange={(value) => setEmailWithInvoiceAttachment(value)}
              checked={emailWithInvoiceAttachment}
              label={translate("Email with Invoice attached")}
            ></PCheck>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <PCheck
              onChange={(value) => setDenominationInDayClose(value)}
              checked={denominationInDayClose}
              label={translate("Denominated Amount In Day Close")}
            ></PCheck>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <PCheck
              onChange={(value) => setVoidReceipt(value)}
              checked={voidReceipt}
              label={translate("Void Receipt")}
            ></PCheck>
          </td>
        </tr>
        {props.context.appType === "R_POS" && (
          <tr>
            <td colSpan={2}>
              <PCheck
                onChange={(value) => setEnableTakeAwayToken(value)}
                checked={enableTakeAwayToken}
                label={translate("Print Takeaway Token")}
              ></PCheck>
            </td>
          </tr>
        )}
        <tr>
          <td>
            <Typography variant="body1">
              {translate("Pole Display Welcome Message Line 1")}
            </Typography>
          </td>
          <td width={200}>
            <PText
              type={"text"}
              value={poleDisplayDefaultMessage1}
              error={poleDisplayDefaultMessage1Error}
              onChange={(e) => setPoleDisplayDefaultMessage1(e.target.value)}
            ></PText>
          </td>
        </tr>
        <tr>
          <td>
            <Typography variant="body1">
              {translate("Pole Display Welcome Message Line 2")}
            </Typography>
          </td>
          <td width={200}>
            <PText
              type={"text"}
              value={poleDisplayDefaultMessage2}
              error={poleDisplayDefaultMessage2Error}
              onChange={(e) => setPoleDisplayDefaultMessage2(e.target.value)}
            ></PText>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <PCheck
              onChange={(value) => setShowTerminalInfoOnSaleScreen(value)}
              checked={showTerminalInfoOnSaleScreen}
              label={translate("Show Terminal Info on Sales Screen")}
            ></PCheck>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <PCheck
              onChange={(value) => setShowKeyboardShortcuts(value)}
              checked={showKeyboardShortcuts}
              label={translate("Show Keyboard Shortcuts")}
            ></PCheck>
          </td>
        </tr>
      </tbody>
    </table>
  );

  function validate() {
    setLiveValidation(true);
    return true;
  }

  function validateItemCodeLen() {}

  function createPayload(payload) {
    payload["dayOpenClose"] = dayOpenClose;
    payload["receiptPrinting"] = receiptPrinting;
    payload["includeTaxInAdjustedPrice"] = includeTaxInAdjustedPrice;
    payload["discountOnFinalPrice"] = discountOnFinalPrice;
    payload["directSettlement"] = directSettlement;
    payload["duplicateInvoice"] = duplicateInvoice;
    payload["poleDisplayDefaultMessage1"] = poleDisplayDefaultMessage1;
    payload["poleDisplayDefaultMessage2"] = poleDisplayDefaultMessage2;
    payload["creditLimitOverride"] = creditLimitOverride;
    payload["limitDaysOverride"] = limitDaysOverride;
    payload["allowHoldInvoice"] = allowHoldInvoice;
    payload["preventZeroStockSale"] = preventZeroStockSale;
    payload["preventBelowCostSale"] = preventBelowCostSale;

    payload["saveOptionInSales"] = saveOptionInSales;
    payload["allowSalePaymentWithoutCustomer"] =
      allowSalePaymentWithoutCustomer;
    payload["enableRoundoffSaleAmount"] = enableRoundoffSaleAmount;
    payload["roundOffFactor"] = roundOffFactor;

    payload["showPrintConfirmation"] = showPrintConfirmation;
    payload["autoClosePayment"] = autoClosePayment;
    payload["itemNotFoundAlert"] = itemNotFoundAlert;
    payload["showLastBillSummary"] = showLastBillSummary;
    payload["emailWithInvoiceAttachment"] = emailWithInvoiceAttachment;
    payload["denominationInDayClose"] = denominationInDayClose;
    payload["voidReceipt"] = voidReceipt;
    payload["enableTakeAwayToken"] = enableTakeAwayToken;
    payload["showTerminalInfoOnSaleScreen"] = showTerminalInfoOnSaleScreen;
    payload["showKeyboardShortcuts"] = showKeyboardShortcuts;
  }

  function populateObject(bean) {
    console.log(bean);
    setDayOpenClose(bean.dayOpenClose);
    setReceiptPrinting(bean.receiptPrinting);
    setIncludeTaxInAdjustedPrice(bean.includeTaxInAdjustedPrice);
    setDiscountOnFinalPrice(bean.discountOnFinalPrice);
    setDirectSettlement(bean.directSettlement);
    setDuplicateInvoice(bean.duplicateInvoice);
    setPoleDisplayDefaultMessage1(bean.poleDisplayDefaultMessage1);
    setPoleDisplayDefaultMessage2(bean.poleDisplayDefaultMessage2);
    setCreditLimitOverride(bean.creditLimitOverride);
    setLimitDaysOverride(bean.limitDaysOverride);
    setAllowHoldInvoice(bean.allowHoldInvoice);
    setPreventZeroStockSale(bean.preventZeroStockSale);
    setPreventBelowCostSale(bean.preventBelowCostSale);

    setSaveOptionInsales(bean.saveOptionInSales);
    setItemNotFoundAlert(bean.itemNotFoundAlert);
    setShowLastBillSummary(bean.showLastBillSummary);
    setEmailWithInvoiceAttachment(bean.emailWithInvoiceAttachment);
    setDenominationInDayClose(bean.denominationInDayClose);
    setVoidReceipt(bean.voidReceipt);
    setEnableTakeAwayToken(bean.enableTakeAwayToken);
    setAllowSalePaymentWithoutCustomer(
      bean.allowSalePaymentWithoutCustomer != null &&
        bean.allowSalePaymentWithoutCustomer != undefined
        ? bean.allowSalePaymentWithoutCustomer
        : true
    );
    setEnableRoundoffSaleAmount(
      bean.enableRoundoffSaleAmount != null &&
        bean.enableRoundoffSaleAmount != undefined
        ? bean.enableRoundoffSaleAmount
        : false
    );
    setRoundOffFactor(
      bean.roundOffFactor != null && bean.roundOffFactor != undefined
        ? bean.roundOffFactor
        : "1"
    );
    setShowPrintConfirmation(
      bean.showPrintConfirmation != null &&
        bean.showPrintConfirmation != undefined
        ? bean.showPrintConfirmation
        : false
    );
    setAutoClosePayment(
      bean.autoClosePayment != null && bean.autoClosePayment != undefined
        ? bean.autoClosePayment
        : true
    );
    setShowTerminalInfoOnSaleScreen(bean.showTerminalInfoOnSaleScreen);
    setShowKeyboardShortcuts(bean.showKeyboardShortcuts);
  }

  return (
    <PSettingsCard
      avatar="S"
      title={translate("Sale Settings")}
      cardContent={content}
      onValidate={validate}
      createPayload={createPayload}
      populateObject={populateObject}
      messagHandler={props.messagHandler}
      settingKey="sale"
    ></PSettingsCard>
  );
}
